import { render, staticRenderFns } from "./Capa.vue?vue&type=template&id=5b978539&scoped=true"
import script from "./Capa.vue?vue&type=script&lang=js"
export * from "./Capa.vue?vue&type=script&lang=js"
import style0 from "./Capa.vue?vue&type=style&index=0&id=5b978539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b978539",
  null
  
)

export default component.exports